import React from 'react'
import { Form, Modal } from 'antd'
import { Input } from '@/ui'

const Content = ({ form }) => (
    <Form form={form} labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
        <Form.Item
            label="命名"
            name="selectName"
            rules={[
                { required: true, message: '请输入快捷查询名称' },
                {
                    validator: (_, value) => {
                        if (!!value && !value.trim()) {
                            return Promise.reject(new Error('请输入快捷查询名称'))
                        }
                        if (!!value && value.trim().length > 10) {
                            return Promise.reject(new Error('命名最长不得超过10个字'))
                        }
                        return Promise.resolve()
                    }
                }
            ]}
            colon={false}
            style={{ marginRight: 80, marginTop: 20 }}
        >
            <Input placeholder="请输入快捷查询名称" />
        </Form.Item>
    </Form>
)

const QuickSearchModal = props => {
    const [form] = Form.useForm()
    const handelOk = async () => {
        await form.validateFields()
        const { selectName } = form.getFieldsValue()
        props.onOk?.(selectName)
        props.onCancel?.()
    }
    return (
        <Modal title="另存为快捷查询条件" {...props} destroyOnClose onOk={handelOk} okText="保存">
            <Content form={form} />
        </Modal>
    )
}
export default QuickSearchModal
